// 只共享界面偏好，不保存身份或权限。生产后台隔离 origin，因此 localStorage 的同名键不能跨后台同步。
const KEY = 'console.rail';
const COOKIE = 'console_rail';
let memory = null;

function cookiePreference() {
  const value = document.cookie.split(';').map(part => part.trim()).find(part => part.startsWith(COOKIE + '='))?.slice(COOKIE.length + 1);
  return value === '1' || value === '0' ? value : null;
}

function save(value) {
  memory = value;
  try { localStorage.setItem(KEY, value); } catch { /* 存储被禁用时保留本页偏好 */ }
  // 只在内部后台的域下共享；本地开发用 host cookie（cookie 不按端口隔离）。不扩大到官网或其他服务。
  const host = location.hostname;
  const domain = host === 'console.pophie.com' || host.endsWith('.console.pophie.com') ? '; Domain=console.pophie.com' : '';
  const secure = location.protocol === 'https:' ? '; Secure' : '';
  document.cookie = `${COOKIE}=${value}; Path=/; Max-Age=31536000; SameSite=Lax${domain}${secure}`;
}

function preference() {
  const cookie = cookiePreference();
  if (cookie !== null) return cookie;
  if (memory !== null) return memory;
  let old = null;
  try { old = localStorage.getItem(KEY); } catch { /* 未选过时按窗口宽度决定 */ }
  if (old === '1' || old === '0') { save(old); return old; }
  return null;
}

export function sidebarMode() {
  if (window.innerWidth < 640) return 'phone';
  const pref = preference();
  return pref === '1' || (pref === null && window.innerWidth < 1024) ? 'rail' : 'expanded';
}

export function applyRail() {
  const rail = sidebarMode() === 'rail';
  document.documentElement.toggleAttribute('data-rail', rail);
  document.querySelectorAll('.sb-collapse').forEach(button => {
    const label = rail ? '展开侧栏' : '收起侧栏';
    button.setAttribute('aria-label', label);
    button.setAttribute('title', label);
    button.setAttribute('aria-expanded', String(!rail));
  });
}

export function toggleRail() {
  if (sidebarMode() === 'phone') return;
  const keepToggleFocus = document.activeElement?.classList.contains('sb-collapse');
  save(sidebarMode() === 'rail' ? '0' : '1');
  applyRail();
  // 控制换了位置，键盘焦点跟到新可见按钮；窗口/跨后台同步不抢其他控件的焦点。
  if (keepToggleFocus) {
    const slot = sidebarMode() === 'rail' ? '.bar-location > .sb-collapse' : '.sb-top > .sb-collapse';
    document.querySelector(slot)?.focus({ preventScroll: true });
  }
  window.dispatchEvent(new Event('console-sidebar-change'));
}

// cookie 没有跨标签事件：切回窗口/标签时重读。清登录会话不清界面偏好，下次登录仍保留。
export function subscribeSidebar(listener) {
  const update = () => { applyRail(); listener(); };
  for (const event of ['resize', 'focus', 'storage', 'console-sidebar-change']) window.addEventListener(event, update);
  document.addEventListener('visibilitychange', update);
  update();
  return () => {
    for (const event of ['resize', 'focus', 'storage', 'console-sidebar-change']) window.removeEventListener(event, update);
    document.removeEventListener('visibilitychange', update);
  };
}
